import styled, { css } from 'styled-components'
import SelectCreatable from 'react-select/creatable'

import Box from '../Box'
import colors from '../../constants/colors'

import { CascaderOption, SelectInputProps } from './Select.types'

export const StyledSelect = styled(SelectCreatable)<SelectInputProps>`
  .select__single-value {
    font-size: 14px;
    margin: 0;
    line-height: 22px;
  }

  .select__placeholder {
  }

  .select__value-container {
    padding: 0;
  }

  .select__input-container {
    margin: 0px;
    padding: 0;
  }

  .select__control {
    border-radius: 8px;
    border-color: ${(props) => (props.isError ? colors.red50 : colors.black10)};
    padding: ${(props) => (props.size === 'small' ? '8px 12px' : '12px 16px')};
    gap: ${(props) => (props.size === 'small' ? '8px' : '10px')};
    cursor: pointer;

    &:hover {
      border-color: ${(props) => (props.isError ? colors.red50 : colors.blue50)};
    }
  }

  .select__indicator-separator {
    display: none;
  }

  .select__indicator {
    padding: 0;
  }

  .select__control--is-focused,
  .select__control--menu-is-open {
    border-color: ${(props) => (props.isError ? colors.red50 : colors.blue50)};
    box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  .select__option {
    cursor: pointer;

    &:active {
      background-color: ${colors.black5};
      color: ${colors.black75};
    }
  }

  .select__menu {
    font-size: 14px;
    color: ${colors.black75};
  }

  .select__option--is-selected,
  .select__option--is-focused {
    background-color: ${colors.black5};
    color: ${colors.black75};
  }

  .select__multi-value {
    &__label {
      font-size: 12px;
    }
  }

  .select__control--menu-is-open {
    .select__dropdown-indicator {
      transform: rotate(180deg);
    }
  }

  .select__input-container {
    font-size: 14px;
  }

  .select__multi-value__remove:hover {
    background-color: transparent;
    color: ${colors.black75};
  }

  .select__menu-list {
    ::-webkit-scrollbar {
      width: 4px;
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${colors.black10};
      border-radius: 16px;
    }
  }

  .select__menu-list:not(:last-child) {
    border-right: 1px solid ${colors.black10};
  }
`

export const StyledCascaderOption = styled(Box)<CascaderOption>`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: inherit;
  width: 100%;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  color: inherit;
  padding: 8px 16px;
  box-sizing: border-box;

  &:hover {
    background-color: ${colors.black5};
  }

	${(props) =>
    props.isDisabled &&
    css`
      color: ${colors.black25};
			cursor: not-allowed;
    `}

  ${(props) =>
    props.isSelected &&
    css`
      color: ${colors.blue50};
      font-weight: 700;
    `}
`
export const StyledOptionText = styled(Box)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 16px;
`

export const StyledCheckbox = styled.input.attrs(() => ({
  type: 'checkbox',
}))`
  margin-right: 8px;
`
